<mat-card class="m-10 p-0">
  <mat-card-header class="titreFrm">
    <mat-card-title>Stock</mat-card-title>
  </mat-card-header>
  <mat-card-content class="border p-8 pt-16 grid-cols-3" style="display: grid">
    <div class="flex justify-between col-span-2">
      <unilog-recherche
        class="w-full mr-4"
        appearance="outline"
        champsModel="Art_Code"
        champsAffiche="Art_Code"
        [(ngModel)]="article"
        [ServerSideFiltering]="true"
        textErreur="Veuillez Entrer un tier valide"
        [showError]="true"
        recherche="article"
        [api]="generalService.api"
        placeholder="Article"
        (ChampEnter)="searchArticle()"
      >
      </unilog-recherche>
    </div>
    <br />
    <div *ngIf="data" class="w-full grid rounded-md shadow-md col-span-full">
      <div class="border-b text-3xl font-bold p-4">Détails de l'article</div>
      <div class="grid grid-cols-2 text-2xl">
        <div class="flex p-8 gap-2">
          <span class="text-gray-500 uppercase w-1/3">Desigiation</span>
          <span class="text-gray-800">{{ data.Art_Des }}</span>
        </div>
        <div class="flex p-8 gap-2">
          <span class="text-gray-500 uppercase w-1/3">Catégorie</span>
          <span class="text-gray-800">{{ data.ArtCat_Code }}</span>
        </div>
        <div class="flex p-8 gap-2">
          <span class="text-gray-500 uppercase w-1/3">Famille</span>
          <span class="text-gray-800">{{ data.Art_Famille1 }}</span>
        </div>
        <div class="flex p-8 gap-2">
          <span class="text-gray-500 uppercase w-1/3">Famille 2</span>
          <span class="text-gray-800">{{ data.Art_Famille2 }}</span>
        </div>
        <div class="flex p-8 gap-2">
          <span class="text-gray-500 uppercase w-1/3">Famille 3</span>
          <span class="text-gray-800">{{ data.Art_Famille3 }}</span>
        </div>
        <div class="flex p-8 gap-2">
          <span class="text-gray-500 uppercase w-1/3">Stock</span>
          <span class="text-gray-800">{{ data.stock }}</span>
        </div>
        <div class="flex p-8 gap-2">
          <span class="text-gray-500 uppercase w-1/3">Stock min</span>
          <span class="text-gray-800">{{ data.Art_StocMin }}</span>
        </div>
        <div class="flex p-8 gap-2">
          <span class="text-gray-500 uppercase w-1/3">Stock max</span>
          <span class="text-gray-800">{{ data.Art_StocMax }}</span>
        </div>
      </div>
    </div>
  </mat-card-content>
</mat-card>
